import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { FaRegThumbsUp } from 'react-icons/fa';
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
    const form = useRef();
    const [evalue, setEValue] = useState("");
    const [nvalue, setNValue] = useState("");
    const [mvalue, setMValue] = useState("");

    const sendEmail = (e) => {
        if (evalue === "") {
            alert("Please provide your email")
        }
        else if (nvalue === "") {
            alert("Please provide your name")
        }
        else if (mvalue === "") {
            alert("Please provide your message");
        }
        else {
            e.preventDefault(); 
            emailjs.sendForm(process.env.REACT_APP_SERVICEID, process.env.REACT_APP_TEMPLATEID, form.current, process.env.REACT_APP_PUBLICKEY)
                .then((result) => {
                    window.location.reload();
                }, (error) => {
                    console.log(error.text);
                });
        }

    };

    return (
        <>
            <Col lg={12} style={{ backgroundColor: "#dddddd", padding: "50px" }}>
                <h3 style={{ marginBottom: "20px" }}>
                    Don't worry ! You're not alone, It’s never too late. Let’s deal it together <FaRegThumbsUp style={{ color: "#6883BC" }} />
                </h3>
                <Form ref={form}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email address *</Form.Label>
                        <Form.Control type="email" placeholder="Enter your email address" onChange={(e) => { setEValue(e.target.value) }} name="user_email" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Name *</Form.Label>
                        <Form.Control type="text" placeholder="Enter your name" onChange={(e) => { setNValue(e.target.value) }} name="user_name" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Message *</Form.Label>
                        <Form.Control as="textarea"
                            placeholder="Leave a Message here"
                            name="message"
                            style={{ height: '100px' }}
                            onChange={(e) => { setMValue(e.target.value) }}
                        />
                    </Form.Group>
                    <Button style={{ backgroundColor: "#6883BC", borderRadius: "0", border: "none" }} onClick={sendEmail} >
                        Submit
                    </Button>
                </Form>
            </Col></>
    );
}

export default Contact;